import React from "react";
import footerButton from "../../assets/images/footer_button.png";
import shieldImg from "../../assets/images/shield-check_bottom.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
} from "../../assets/icons";

export default function Footer() {
  const notify = () => {
    toast.dismiss(); // Dismiss any existing toasts
    toast("This feature will be available soon. Stay tuned for updates.");
  };

  return (
    <div className="relative w-full">
      {/* Main White Footer */}
      <footer className="bg-white border-t border-gray-200 relative z-10 pt-8 md:pt-12 pb-8 overflow-hidden" id="footer">
        <div className="container relative mx-auto px-6 md:px-0">
          <div className="flex flex-col justify-between text-gray-900 md:flex-row gap-8 md:gap-0">
            <section className="w-full md:w-[375px]">
              <h1 className="text-left font-manrope text-[20px] font-extrabold leading-[22px] text-gray-900 md:text-[22px] md:font-[800] md:leading-[32px] 2xl:text-[28px]">
                Geo Vpn
              </h1>

              <p className="mb-[20px] mt-[12px] w-full max-w-[320px] text-left font-manrope text-[13px] font-semibold leading-[18px] text-gray-600 md:max-w-fit">
                Protect your online privacy and secure your data with a reliable
                VPN app. Just download and enjoy safe, unrestricted internet
                access.
              </p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&hl=en_US&gl=US"
              >
                <img
                  src={footerButton}
                  alt="button"
                  className="hidden min-h-[36px] w-[200px] md:block"
                />
              </a>
            </section>
            
            <section className="w-[192.47px]">
              <h1 className="mb-[16px] text-left font-manrope text-[15px] font-extrabold leading-[15px] text-gray-900 md:text-[18px] md:leading-[28px]">
                Contact Us
              </h1>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com"
                className="mb-[10px] flex flex-row items-center gap-[10px] no-underline text-gray-700 hover:text-[#5072F1] [&_path]:fill-gray-700 hover:[&_path]:fill-[#5072F1] transition-colors"
              >
                <FacebookIcon />
                <p className="text-left font-manrope text-[13px] font-medium leading-none">
                  Facebook
                </p>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com"
                className="mb-[10px] flex flex-row items-center gap-[10px] no-underline text-gray-700 hover:text-[#5072F1] [&_path]:fill-gray-700 hover:[&_path]:fill-[#5072F1] transition-colors"
              >
                <InstagramIcon />
                <p className="text-left font-manrope text-[13px] font-medium leading-none">
                  Instagram
                </p>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com"
                className="mb-[10px] flex flex-row items-center gap-[10px] no-underline text-gray-700 hover:text-[#5072F1] [&_path]:fill-gray-700 hover:[&_path]:fill-[#5072F1] transition-colors"
              >
                <LinkedInIcon />
                <p className="text-left font-manrope text-[13px] font-medium leading-none">
                  LinkedIn
                </p>
              </a>
              <a
                className="flex flex-row items-center gap-[10px] no-underline text-gray-700 hover:text-[#5072F1] [&_path]:fill-gray-700 hover:[&_path]:fill-[#5072F1] transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.x.com"
              >
                <TwitterIcon />
                <p className="text-left font-manrope text-[13px] font-medium leading-none">
                  X
                </p>
              </a>
            </section>
            <img
              src={footerButton}
              alt="button"
              className="mt-4 block h-[40px] w-[130px] cursor-pointer md:hidden"
              onClick={notify}
            />
          </div>

          <div className="mt-8 border-t border-gray-200 text-center pt-6">
            <p className="text-center font-manrope text-xs text-gray-500">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://sites.google.com/view/privacypolicygeovpn/home"
                className="border-dotted border-gray-400 hover:border-b text-gray-600 hover:text-gray-900 no-underline"
              >
                Privacy Policy
              </a>
              {" "} | Terms & Conditions | Cookies Policy
            </p>
          </div>
          
          <img
            src={shieldImg}
            alt="img"
            className="absolute right-0 bottom-0 -z-10 hidden md:block h-[280px] w-auto pointer-events-none opacity-10"
          />
        </div>
        <ToastContainer />
      </footer>
    </div>
  );
}
